import constants from "../../constants";
import NativeBackgroundListener from "./nativeBackgroundListener";
import * as logger from "../../utils/logger";
import { AppType, getAppType } from "./nativeHelpers";

function enableBackgroundModeCordova(foregroundHandler: () => void, backgroundHandler: () => void, failureHandler: (code: any) => void) {
    if (window.cordova.plugins && window.cordova.plugins.backgroundMode) {
        window.cordova.plugins.backgroundMode.setDefaults({
            title: constants.APP_NAME,
            text: "Touch to open",
            ticker: "Geotab Drive is still running"
        });

        // Current plugin event handlers
        if (window.cordova.plugins.backgroundMode.on) {
            window.cordova.plugins.backgroundMode.on("activate", foregroundHandler);
            window.cordova.plugins.backgroundMode.on("deactivate", backgroundHandler);
            window.cordova.plugins.backgroundMode.on("failure", failureHandler);
        }

        // Legacy handlers
        window.cordova.plugins.backgroundMode.onactivate = foregroundHandler;
        window.cordova.plugins.backgroundMode.ondeactivate = backgroundHandler;
        window.cordova.plugins.backgroundMode.onfailure = failureHandler;

        window.cordova.plugins.backgroundMode.enable();
    }
}

function disableCordovaBackgroundMode(foregroundHandler: () => void, backgroundHandler: () => void, failureHandler: (code: any) => void, backgroundListener: NativeBackgroundListener) {
    window.addEventListener("unload", function () {
        // Stop the background mode plugin when we redirect to a new page
        if (window.cordova.plugins && window.cordova.plugins.backgroundMode) {
            window.cordova.plugins.backgroundMode.disable();

            // Current plugin event handlers
            if (window.cordova.plugins.backgroundMode.un) {
                window.cordova.plugins.backgroundMode.un("activate", foregroundHandler);
                window.cordova.plugins.backgroundMode.un("deactivate", backgroundHandler);
                window.cordova.plugins.backgroundMode.un("failure", failureHandler);
            }

            // Legacy handlers
            window.cordova.plugins.backgroundMode.onactivate = constants.NOOP;
            window.cordova.plugins.backgroundMode.ondeactivate = constants.NOOP;
            window.cordova.plugins.backgroundMode.onfailure = constants.NOOP;
        }
        if (backgroundListener) {
            backgroundListener.destroy();
        }
    });
}

function getCordovaHandlers(backgroundListener: NativeBackgroundListener) {
    let foregroundHandler = backgroundListener.foregroundEvent.bind(backgroundListener);
    let backgroundHandler = backgroundListener.backgroundEvent.bind(backgroundListener);
    let failureHandler = backgroundListener.failureEvent.bind(backgroundListener);
    return { foregroundHandler, backgroundHandler, failureHandler };
}

function handleNativeSDKBackgroundMode(backgroundListener: NativeBackgroundListener) {
    window.addEventListener("app.background", function() {
        if (!window.geotabModules) {
            return;
        }
        if (window.geotabModules.app.background) {
            backgroundListener.foregroundEvent();
        } else {
            backgroundListener.backgroundEvent();
        }
    });
}

export function handleBackgroundMode() {
    let errorLog = function () {
        logger.event(logger.Event.BACKGROUNDFAILURE, "Excessive Background Switch Logs being created!");
    };
    let backgroundListener = new NativeBackgroundListener(60000, 100, errorLog);

    switch (getAppType()) {
        case AppType.CordovaApp: {
            let { foregroundHandler, backgroundHandler, failureHandler } = getCordovaHandlers(backgroundListener);
            enableBackgroundModeCordova(foregroundHandler, backgroundHandler, failureHandler);
            disableCordovaBackgroundMode(foregroundHandler, backgroundHandler, failureHandler, backgroundListener);
        }
        break;
        case AppType.NativeSdk:
            handleNativeSDKBackgroundMode(backgroundListener);
            break;
        default:
            break;
    }
}